import { ReactElement } from 'react';
import { AppRouter } from '../router/AppRouter';
export const Widget = (): ReactElement => {
    return <AppRouter />;
};
